import CONFIGS from 'configs';
import en from './en.json';
import petcard from './petcard.json';

const clientSpecificTranslations =
  {
    // CLIENT SPECIFIC TRANSLATIONS
    petcard,
  }[CONFIGS.ENV] || {};

export default { ...en, ...clientSpecificTranslations };
